import { previewBlockFetched } from './sync';
import { getBlockData } from '../../api/endpoints/preview';
export const fetchPreviewBlock = (id, workId, auth) => dispatch => {
  return getBlockData(id, workId, auth).then(({ data }) => {
    dispatch(previewBlockFetched(data));
  });
};
